import { render } from "./Offset.vue?vue&type=template&id=42f6dd4e&scoped=true"
import script from "./Offset.vue?vue&type=script&lang=js"
export * from "./Offset.vue?vue&type=script&lang=js"

import "./Offset.vue?vue&type=style&index=0&id=42f6dd4e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42f6dd4e"]])

export default __exports__